import { render } from "./HomePageView.vue?vue&type=template&id=5d8f81bc&scoped=true"
import script from "./HomePageView.vue?vue&type=script&lang=js"
export * from "./HomePageView.vue?vue&type=script&lang=js"

import "./HomePageView.vue?vue&type=style&index=0&id=5d8f81bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8f81bc"]])

export default __exports__